import React, { ReactNode } from 'react';
import cn from 'classnames';

export interface IProgressBarProps {
    animated?: boolean,
    children?: ReactNode,
    className?: string,
    striped?: boolean,
    variant?: 'default' | 'info' | 'success' | 'warn' | 'danger',
    value: number,
}

export function ProgressBar({ animated, children, className, striped, variant = 'default', value }: IProgressBarProps) {
    value = Math.max(0, Math.min(100, value));

    return <div
        className={cn('progress-bar', className, {
            'progress-bar-info': variant === 'info',
            'progress-bar-success': variant === 'success',
            'progress-bar-warn': variant === 'warn',
            'progress-bar-danger': variant === 'danger',
            'progress-bar-striped': striped,
            'progress-bar-animated': animated,
        })}
        role="progressbar"
        style={{width: value + '%'}}
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
    >
        {children}
    </div>
}